const GLOBAL_CYCLE_DURATION = 12 * 60 * 60; // 12 hours = 43,200 seconds
const PST_OFFSET = 8 * 60 * 60; // PST is fixed UTC-8 (not DST-adjusted), so boundaries land on 12am/12pm PST

if (!customElements.get('util-countdown')) {
  class UtilCountdown extends HTMLElement {
    constructor() {
      super();
      this.countdown = this.querySelector('.util-countdown');
      this.runningEl = this.querySelector('.util-countdown-running');
      this.defaultEl = this.querySelector('.util-countdown-default');
      this.numbersStyle = this.dataset.numbersStyle || '';
      this.mode = this.dataset.mode || 'global_cycle';
      this.hours = parseFloat(this.dataset.hours) || 0;
      this.minutes = parseFloat(this.dataset.minutes) || 0;
      this.seconds = parseFloat(this.dataset.seconds) || 0;
      this.storageKey = 'util_countdown_end_' + (this.dataset.key || 'default');
      this.end = null;
      this.tick();
    }

    getEnd() {
      const span = (this.hours * 3600 + this.minutes * 60 + this.seconds) * 1000;

      if (this.mode === 'evergreen') {
        const now = Date.now();
        let end;
        try { end = parseInt(localStorage.getItem(this.storageKey), 10); } catch (e) {}
        if (!end || isNaN(end) || end < now) {
          end = now + span;
          try { localStorage.setItem(this.storageKey, end); } catch (e) {}
        }
        return end;
      }

      if (this.mode === 'fixed') {
        const tz = parseFloat(this.dataset.timezone) || 0;
        let end = Date.parse(this.dataset.date + ' GMT');
        if (isNaN(end)) { end = Date.now() + span; } else { end -= tz * 3600 * 1000; }
        return end;
      }

      // global_cycle (default/legacy): repeats forever, synced to real
      // clock boundaries every GLOBAL_CYCLE_DURATION seconds (shifted by
      // PST_OFFSET so the boundaries land on 12am/12pm PST).
      const now = Math.floor(Date.now() / 1000) - PST_OFFSET;
      const remainingSeconds = GLOBAL_CYCLE_DURATION - (now % GLOBAL_CYCLE_DURATION);
      return Date.now() + remainingSeconds * 1000;
    }

    tick() {
      if (this.end === null) { this.end = this.getEnd(); }

      let distance = this.end - Date.now();

      if (distance <= 0) {
        if (this.mode === 'evergreen') {
          this.end = null;
          this.end = this.getEnd();
          distance = this.end - Date.now();
        } else if (this.mode === 'fixed') {
          if (this.runningEl) this.runningEl.style.display = 'none';
          if (this.countdown) this.countdown.style.display = 'none';
          if (this.defaultEl) this.defaultEl.style.display = '';
          return;
        } else {
          // global_cycle always has a fresh boundary ahead, but guard
          // against clock drift by recomputing.
          this.end = this.getEnd();
          distance = this.end - Date.now();
        }
      }

      const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0').split('');
      const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0').split('');
      const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0').split('');
      const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0').split('');

      const html = `
        <div class="group days">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${days[0]}</span><span>${days[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__days_label || 'Days'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group hours">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${hours[0]}</span><span>${hours[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__hours_label || 'Hours'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group minutes">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${minutes[0]}</span><span>${minutes[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__minutes_label || 'Minutes'}</div>
        </div>
        <div class="dash">:</div>

        <div class="group seconds">
          <div class="numbers flex ${this.numbersStyle}">
            <span>${seconds[0]}</span><span>${seconds[1]}</span>
          </div>
          <div class="small-label">${lngg?.util_countdown_js__seconds_label || 'Seconds'}</div>
        </div>
      `;

      if (this.countdown) {
        this.countdown.innerHTML = html;
      }

      // Update every second
      setTimeout(this.tick.bind(this), 1000);
    }
  }

  customElements.define('util-countdown', UtilCountdown);
}
